let googleMapsScriptLoadingPromise: Promise<void> | null = null;

const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

export function loadGoogleMapsScriptConfig(): Promise<void> {
  if (typeof window === 'undefined') return Promise.reject('No window object');

  if (window.google && window.google.maps) {
    return Promise.resolve();
  }

  if (googleMapsScriptLoadingPromise) {
    return googleMapsScriptLoadingPromise;
  }

  const script = document.createElement('script');
  script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places&language=en`;
  script.async = true;
  script.defer = true;
  script.id = 'google-maps-api';

  googleMapsScriptLoadingPromise = new Promise((resolve, reject) => {
    script.onload = () => resolve();
    script.onerror = err => reject(err);
  });

  document.head.appendChild(script);

  return googleMapsScriptLoadingPromise;
}
